import request from '@/axios'


export function getCourseWithTeacher (platform_customer_id, payload = null) {
  return request({
    url:`course/list/short/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

export function enrolledStudentList (platform_customer_id, payload) {
  return request({
    url:`course/student/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

export function setAttendanceApi (platform_customer_id, payload) {
  return request({
    url:`course/attendance/submit/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

export function setTeacherAttendanceApi (platform_customer_id, payload) {
  return request({
    url:`course/attendance/submit/user/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}


// course/attendance/fetch/{customer_id} =>post

export function fetchSingleAttendanceHistoryApi (platform_customer_id, payload) {
  return request({
    url:`course/attendance/fetch/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function fetchTeacherSingleAttendanceHistoryApi (platform_customer_id, payload) {
  return request({
    url:`course/attendance/fetch/user/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}


export function getAttendanceDate (platform_customer_id, payload) {
  return request({
    url:`course/attendance_date/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getStudentList (platform_customer_id) {
  return request({
    url:`clientUser/list/short/${platform_customer_id}`,
    method:'GET'
  })
}

export function getClassStudentAttendanceApi (platform_customer_id,payload) {
  return request({
    url:`classes/attendance/fetch/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function setClassStudentAttendanceApi (platform_customer_id, payload) {
  return request({
    url:`classes/attendance/submit/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}


export function fetchClassesTeacherSingleAttendanceHistoryApi (platform_customer_id, payload) {
  return request({
    url:`classes/attendance/fetch/user/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function setClassTeacherAttendanceApi (platform_customer_id, payload) {
  return request({
    url:`classes/attendance/submit/user/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

// {{URL}}/}---------------------POST
// {
//     "class_id": 34,
//     "start_date":"2021-07-20",
//     "end_date":"2021-07-20"
// }